export default function ServicesParallax() {
  return (
    <section
      className="relative min-h-[70vh] flex items-center justify-center bg-fixed bg-center bg-cover"
      style={{
        backgroundImage:
          "linear-gradient(rgba(46, 51, 41, 0.90), rgba(46, 51, 41, 0.90)), url('https://images.unsplash.com/photo-1524995997946-a1c2e315a42f')",
      }}
    >
      <div className="max-w-7xl mx-auto text-center px-6 py-20">
        {/* Author image and name at the top, similar to AuthorsOfMonth */}
        <div className="flex flex-col items-center mb-8">
          <div className="flex justify-center mb-4">
            <img
              src="/author.jpeg"
              alt="Sweta Singh"
              className="w-36 h-36 rounded-full object-cover border-4 border-[#e0dac2] shadow-lg"
            />
          </div>
          <h3 className="font-serif text-xl text-[#fff] mb-2">Sweta Singh</h3>
        </div>
        <div className="flex justify-center mb-3">
          <span className="text-white text-3xl">❦</span>
        </div>
        <h2 className="text-white/90 font-serif text-2xl sm:text-3xl tracking-widest mb-8">
          About The Author: Sweta Singh
        </h2>
        <div className="text-white/95 text-lg leading-loose font-light space-y-6 whitespace-pre-line">
          <p>
            Sweta Singh writes stories for the places people don’t always speak about — the quiet corners of the heart, the hidden rooms of memory, and the fragile space between truth and silence.
          </p>
          <p>
            Her debut novel, <span className="italic">When the Rain Paused</span>, moves into a different emotional landscape — a deeply romantic, intense love story set against longing, loss, and destiny. Where Rain explores what stays — love that survives distance, fear, and time.
          </p>
          <p>
            Her second novel, <span className="italic">When the Shadows Spoke</span>, is a dark, emotionally layered thriller that explores identity, erased histories, and the invisible cost of doing what is right. It reflects her fascination with how power shapes narratives — and how ordinary people carry extraordinary moral weight when no one is watching.
          </p>
          <p>
            Though her worlds are different, Sweta’s writing is guided by one unwavering belief:{" "}
            <span className="block italic text-[#e0dac2]">
              that the most powerful stories are not only about events — they are about what those events do to the human soul.
            </span>
          </p>
          <p>
            By profession, she is an HR leader, working closely with people, conflict, ambition, emotions and resilience every day. That lived experience flows quietly into her fiction, giving her characters an emotional truth that feels real, flawed, and deeply human.
          </p>
          <p>
            Sweta does not write to escape reality — she writes to understand it. Her stories are for readers who are drawn to emotional depth, layered characters, and narratives that linger long after the final page.
          </p>
          <p>
            She believes that love can be gentle yet fierce, truth can be honest yet dangerous, and silence can carry its own kind of poetry. And through every book, she invites her readers to look beneath the surface — into the places where shadows speak and rain waits to fall.
          </p>
        </div>
      </div>
    </section>
  );
}